import * as React from "react"

interface SideNavCtxType {
  registerLink: (linkTo: string) => void
  setActiveLink: (linkTo: string, linkStatus: boolean) => void
}
export const SideNavCtx = React.createContext<SideNavCtxType>(undefined!)
